import React from 'react'
import { VStack, Text, Button, Heading, Container } from '@chakra-ui/react'

import { WizardStepForm } from 'components'

export const FormSubmissionFinalStep = props => (
  <WizardStepForm {...props} hideNavigation justify='center'>
    <Heading size='4xl' textAlign='center' my={5}>
      Parabéns!
    </Heading>
    <Container my={5}>
      <VStack spacing={5}>
        <Text fontSize='lg' align='center'>
          Concluiu com sucesso o questionário. Consulte no relatório de avaliação o score obtido e
          as recomendações. O relatório pode ser visualizado online ou guardado em versão PDF.
        </Text>
        <Button colorScheme='green' size='lg' type='submit'>
          Submeter e consultar Relatório
        </Button>
      </VStack>
    </Container>
  </WizardStepForm>
)

export default FormSubmissionFinalStep
